import { ipAddressType } from "../type";
const initialState = {
  ipAddressList: [],
  error: undefined,
  isLoading: false,
  message:undefined
};

const IpAddressReducer = (state = initialState, action) => {
  const { payload = {}, type } = action;
  switch (type) {
    case ipAddressType.GET_IP_ADDRESS:
      return {
        ...state,
        ipAddressList: payload,
        isLoading: true,
      };
    case ipAddressType.ADD_IP_ADDRESS:
      
      return {
        ...state,
        ipAddressList: [
          ...state.ipAddressList,
          {
            city: payload.city,
            country: payload.country,
            ip_address: payload.ip_address,
            location: payload.location,
            _id: payload._d,
          },
        ],
      };
    case ipAddressType.UPDATE_IP_ADDRESS:
      
      return {
        ...state,
        ipAddressList: state.ipAddressList.map((list) =>
          list._id === payload.id ? payload : list
        ),
        
      };
    case ipAddressType.DELETE_IP_ADDRESS:
      return {
        ...state,
        ipAddressList:state.ipAddressList.filter((list)=> list._id !== payload._id
        )
      }
      case ipAddressType.IP_ADDRESS_ERROR:
        // console.log("payload",payload)
        return {
          ...state,
          error: payload,
        }
    default: {
      return state;
    }
  }
};

export default IpAddressReducer;
